import { Pagination as NextUIPagination } from '@nextui-org/react'
import React from 'react'
interface PaginationProps {
    currentPage: number
    totalPages: number
    completed: boolean
    onChange?: (page: number) => void
    /** Si es true, muestra la paginación aunque el módulo no esté marcado como completado */
    alwaysVisible?: boolean
}

export const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    totalPages,
    completed,
    onChange,
    alwaysVisible = false
}) => {
    const showPagination = alwaysVisible || completed

    return (
        <div>
            {showPagination && (
                <NextUIPagination
                    isCompact
                    total={totalPages}
                    page={currentPage}
                    showShadow
                    className="flex justify-center"
                    classNames={{
                        wrapper: 'gap-0 overflow-visible h-8  ',
                        item: 'w-8 h-8 text-small rounded-none bg-transparent border border-divider',
                        cursor: 'shadow-lg from-default-500 to-default-800 dark:from-default-300 dark:to-default-100 text-white font-bold'
                    }}
                    onChange={(page) => {
                        onChange?.(page)
                    }}
                />
            )}
        </div>
    )
}
